import { create } from 'zustand';

/**
 * One store for all four Stock Audit drill-downs. They are mutually exclusive
 * — you drill from a row into exactly one thing — so a single slot avoids four
 * near-identical stores and four mounted dialogs.
 */
export type AuditDrilldownTarget =
  | { kind: 'session'; auditId: number }
  | { kind: 'sku'; productId: number; productName?: string | null; storeId?: number | null }
  | { kind: 'packer'; packerId: number; packerName?: string | null }
  | { kind: 'coverageStore'; storeId: number; storeName?: string | null };

interface AuditDrilldownState {
  open: boolean;
  target: AuditDrilldownTarget | null;
  openAuditDrilldown: (t: AuditDrilldownTarget) => void;
  closeAuditDrilldown: () => void;
}

export const useAuditDrilldownStore = create<AuditDrilldownState>((set) => ({
  open: false,
  target: null,
  openAuditDrilldown: (t) => set({ open: true, target: t }),
  closeAuditDrilldown: () => set({ open: false, target: null }),
}));

export function openAuditDrilldown(t: AuditDrilldownTarget) {
  useAuditDrilldownStore.getState().openAuditDrilldown(t);
}

export function closeAuditDrilldown() {
  useAuditDrilldownStore.getState().closeAuditDrilldown();
}

/** Stable key so the dialog body remounts when the target changes. */
export function auditDrilldownKey(t: AuditDrilldownTarget): string {
  switch (t.kind) {
    case 'session':
      return `session-${t.auditId}`;
    case 'sku':
      return `sku-${t.productId}-${t.storeId ?? 'all'}`;
    case 'packer':
      return `packer-${t.packerId}`;
    case 'coverageStore':
      return `coverage-${t.storeId}`;
  }
}
